import { timerTask } from '@/utils/timer'
import { tokenCheck } from '@/services/api/account'
import eventBus from '@/services/bus'
import { i18n } from '@/stores'

/**
 * 令牌校验
 */
export async function checkToken() {
    try {
        return await tokenCheck()
    } catch (err) {
        // 临时解决方案，有可能出现网络问题导致超时后账号被登出
        if (err !== i18n.global.t('common.tips17')) {
            eventBus.$emit('LogoutNotify', i18n.global.t('common.tips18'))
        }
        return Promise.reject(err)
    }
}

/**
 * 轮询校验令牌
 */
export function checkTokenLoop() {
    const delay = 1 * 60 * 1000 // 每1分钟校验一次令牌
    timerTask.setTimeout(() => {
        checkToken().then(() => checkTokenLoop())
    }, delay, 'checkToken')
}

/**
 * 停止令牌校验
 */
export function stopCheckToken() {
    timerTask.clearTimeout('checkToken')
}